// HomeCarousel.tsx

import React, { useEffect, useRef } from "react";
import * as bootstrap from "bootstrap";
import "./home-banner.css";

const HomeCarousel: React.FC = () => {
  const carouselRef =
    useRef<HTMLDivElement>(null);

  // ============================================================
  // BANNERS
  // ============================================================

  const homeBanner1 =
    "https://www.growniverse.com/images//home-banner4.webp";

  const homeBanner2 =
    "https://www.growniverse.com/images//home-banner2.webp";

  const homeBanner3 =
    "https://www.growniverse.com/images//home-banner3.webp";

  const homeBanner5 =
    "https://www.growniverse.com/images//home-banner5.webp";

  const homeBanner6 =
    "https://www.growniverse.com/images//home-banner6.webp";

  const homeBanner7 =
    "https://www.growniverse.com/images//home-banner7.webp";

  const homeBanner8 =
    "https://www.growniverse.com/images//home-banner8.webp";

  const homeBanner9 =
    "https://www.growniverse.com/images//home-banner9.webp";

  // ============================================================
  // BOOTSTRAP CAROUSEL
  // ============================================================

  useEffect(() => {
    if (!carouselRef.current) return;

    const carousel =
      new bootstrap.Carousel(
        carouselRef.current,
        {
          interval: 3500,
          ride: "carousel",
          pause: false,
          wrap: true,
          touch: true,
        }
      );

    return () => {
      carousel.dispose();
    };
  }, []);

  // ============================================================
  // BANNER DATA
  // ============================================================

  const banners = [
    {
      image: homeBanner1,
      alt: "Growniverse education banner",
    },
    {
      image: homeBanner9,
      alt: "Growniverse learning banner",
    },
    {
      image: homeBanner2,
      alt: "Growniverse education banner",
    },
    {
      image: homeBanner3,
      alt: "Growniverse learning banner",
    },
    {
      image: homeBanner7,
      alt: "Growniverse education banner",
    },
    {
      image: homeBanner8,
      alt: "Growniverse learning banner",
    },
    {
      image: homeBanner6,
      alt: "Growniverse education banner",
    },
    {
      image: homeBanner5,
      alt: "Growniverse learning banner",
    },
  ];

  return (
    <>
      {/* ========================================================
          HERO CAROUSEL
      ======================================================== */}

      <div
        id="homeCarousel"
        className="carousel slide carousel-fade futuristic-home-carousel"
        data-bs-ride="carousel"
        ref={carouselRef}
      >
        {/* ======================================================
            SLIDES
        ====================================================== */}

        <div className="carousel-inner futuristic-carousel-inner">
          {banners.map(
            (banner, index) => (
              <div
                key={banner.image}
                className={`carousel-item ${
                  index === 0
                    ? "active"
                    : ""
                }`}
              >
                {/* ==================================================
                    BANNER IMAGE
                ================================================== */}

                <img
                  src={banner.image}
                  alt={banner.alt}
                  className="HomeBannerImg futuristic-banner-image"
                />

                {/* ==================================================
                    DARK CINEMATIC OVERLAY
                ================================================== */}

                <div className="futuristic-banner-overlay" />

                {/* ==================================================
                    CYAN LIGHT
                ================================================== */}

                <div className="futuristic-cyan-glow" />

                {/* ==================================================
                    PURPLE LIGHT
                ================================================== */}

                <div className="futuristic-purple-glow" />

                {/* ==================================================
                    GRID
                ================================================== */}

                <div className="futuristic-grid-overlay" />

                {/* ==================================================
                    CENTER CONTENT
                ================================================== */}

                <div className="futuristic-hero-content">
                  {/* Small badge */}

                  <div className="futuristic-hero-badge">
                    <span className="futuristic-status-dot" />

                    GROWNIVERSE
                  </div>

                  {/* Main heading */}

                  <h1 className="futuristic-hero-title">
                    Best Education
                    <br />

                    <span>
                      From Your Home
                    </span>
                  </h1>

                  {/* Description */}

                  <p className="futuristic-hero-description">
                    Don't change your
                    learning,
                    <br className="mobile-break" />
                    just change the way.
                  </p>

                  {/* Bottom futuristic line */}

                  <div className="futuristic-hero-line">
                    <span />
                    <span />
                    <span />
                  </div>
                </div>

                {/* ==================================================
                    CORNER DETAILS
                ================================================== */}

                <div className="hero-corner hero-corner-top-left" />
                <div className="hero-corner hero-corner-top-right" />
                <div className="hero-corner hero-corner-bottom-left" />
                <div className="hero-corner hero-corner-bottom-right" />
              </div>
            )
          )}
        </div>

        {/* ======================================================
            LEFT CONTROL
        ====================================================== */}

        <button
          className="carousel-control-prev futuristic-carousel-control"
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide="prev"
          aria-label="Previous slide"
        >
          <span className="futuristic-arrow">
            ‹
          </span>
        </button>

        {/* ======================================================
            RIGHT CONTROL
        ====================================================== */}

        <button
          className="carousel-control-next futuristic-carousel-control"
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide="next"
          aria-label="Next slide"
        >
          <span className="futuristic-arrow">
            ›
          </span>
        </button>

        {/* ======================================================
            FUTURISTIC INDICATORS
        ====================================================== */}

        <div className="carousel-indicators futuristic-indicators">
          {banners.map(
            (_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#homeCarousel"
                data-bs-slide-to={index}
                className={
                  index === 0
                    ? "active"
                    : ""
                }
                aria-current={
                  index === 0
                    ? "true"
                    : undefined
                }
                aria-label={`Slide ${
                  index + 1
                }`}
              />
            )
          )}
        </div>

        {/* ======================================================
            BOTTOM SCAN LINE
        ====================================================== */}

        <div className="futuristic-bottom-scan-line" />
      </div>

      {/* ========================================================
          INLINE CSS
      ======================================================== */}

      <style>
        {`
          /* ======================================================
             MAIN CAROUSEL
          ====================================================== */

          .futuristic-home-carousel {
            position: relative;
            width: 100%;
            height: 700px;
            overflow: hidden;
            background: #050810;
          }

          .futuristic-carousel-inner {
            height: 700px;
            overflow: hidden;
          }

          .futuristic-home-carousel
          .carousel-item {
            position: relative;
            height: 700px;
            overflow: hidden;
            background: #050810;
          }


          /* ======================================================
             IMAGE
          ====================================================== */

          .futuristic-banner-image {
            position: absolute;
            inset: 0;

            width: 100% !important;
            height: 100% !important;

            object-fit: cover;

            display: block;

            transform: scale(1.01);

            filter:
              brightness(0.72)
              contrast(1.08)
              saturate(0.95);

            transition:
              transform 6s ease,
              filter 0.8s ease;
          }


          .carousel-item.active
          .futuristic-banner-image {
            transform: scale(1.05);
          }


          /* ======================================================
             DARK CINEMATIC OVERLAY
          ====================================================== */

          .futuristic-banner-overlay {
            position: absolute;
            inset: 0;

            z-index: 1;

            background:
              linear-gradient(
                90deg,
                rgba(2, 5, 12, 0.82) 0%,
                rgba(2, 5, 12, 0.58) 35%,
                rgba(2, 5, 12, 0.32) 65%,
                rgba(2, 5, 12, 0.70) 100%
              );

            pointer-events: none;
          }


          /* ======================================================
             TOP / BOTTOM DARK GRADIENT
          ====================================================== */

          .futuristic-home-carousel
          .carousel-item::after {
            content: "";

            position: absolute;

            inset: 0;

            z-index: 2;

            pointer-events: none;

            background:
              linear-gradient(
                180deg,
                rgba(2, 6, 16, 0.58) 0%,
                transparent 25%,
                transparent 70%,
                rgba(2, 6, 16, 0.78) 100%
              );
          }


          /* ======================================================
             CYAN GLOW
          ====================================================== */

          .futuristic-cyan-glow {
            position: absolute;

            width: 430px;
            height: 430px;

            left: -180px;
            top: -190px;

            border-radius: 50%;

            background:
              rgba(0, 246, 255, 0.12);

            filter:
              blur(100px);

            z-index: 1;

            pointer-events: none;
          }


          /* ======================================================
             PURPLE GLOW
          ====================================================== */

          .futuristic-purple-glow {
            position: absolute;

            width: 450px;
            height: 450px;

            right: -220px;
            bottom: -260px;

            border-radius: 50%;

            background:
              rgba(139, 92, 255, 0.13);

            filter:
              blur(110px);

            z-index: 1;

            pointer-events: none;
          }


          /* ======================================================
             FUTURISTIC GRID
          ====================================================== */

          .futuristic-grid-overlay {
            position: absolute;

            inset: 0;

            z-index: 2;

            pointer-events: none;

            opacity: 0.10;

            background-image:
              linear-gradient(
                rgba(255,255,255,0.055) 1px,
                transparent 1px
              ),
              linear-gradient(
                90deg,
                rgba(255,255,255,0.055) 1px,
                transparent 1px
              );

            background-size:
              45px 45px;

            mask-image:
              linear-gradient(
                to bottom,
                transparent,
                black 20%,
                black 80%,
                transparent
              );
          }


          /* ======================================================
             HERO CONTENT
          ====================================================== */

          .futuristic-hero-content {
            position: absolute;

            z-index: 10;

            top: 50%;
            left: 50%;

            transform:
              translate(-50%, -50%);

            width: min(
              850px,
              88%
            );

            text-align: center;

            color: #ffffff;

            padding:
              25px 30px;
          }


          /* ======================================================
             BADGE
          ====================================================== */

          .futuristic-hero-badge {
            display: inline-flex;

            align-items: center;

            gap: 8px;

            padding:
              8px 16px;

            margin-bottom:
              18px;

            border:
              1px solid
              rgba(0,246,255,0.30);

            border-radius:
              30px;

            background:
              rgba(4,12,24,0.62);

            backdrop-filter:
              blur(12px);

            color:
              #c9faff;

            font-size:
              10px;

            font-weight:
              800;

            letter-spacing:
              3px;

            box-shadow:
              0 0 25px
              rgba(0,246,255,0.08);
          }


          /* ======================================================
             STATUS DOT
          ====================================================== */

          .futuristic-status-dot {
            width: 7px;
            height: 7px;

            border-radius: 50%;

            background:
              #00f6ff;

            box-shadow:
              0 0 12px
              #00f6ff;
          }


          /* ======================================================
             HERO TITLE
          ====================================================== */

          .futuristic-hero-title {
            margin:
              0;

            color:
              #ffffff !important;

            font-size:
              clamp(
                38px,
                5.5vw,
                78px
              );

            line-height:
              1.02;

            font-weight:
              800;

            letter-spacing:
              -2px;

            text-transform:
              none;

            text-shadow:
              0 4px 25px
              rgba(0,0,0,0.75),

              0 0 12px
              rgba(255,255,255,0.30),

              0 0 35px
              rgba(0,246,255,0.12);
          }


          .futuristic-hero-title span {
            background:
              linear-gradient(
                90deg,
                #ffffff 0%,
                #bdfaff 40%,
                #a99aff 100%
              );

            -webkit-background-clip:
              text;

            background-clip:
              text;

            -webkit-text-fill-color:
              transparent;

            filter:
              drop-shadow(
                0 0 14px
                rgba(0,246,255,0.22)
              );
          }


          /* ======================================================
             DESCRIPTION
          ====================================================== */

          .futuristic-hero-description {
            margin:
              22px auto 0;

            color:
              rgba(245,250,255,0.92);

            font-size:
              clamp(
                15px,
                1.7vw,
                20px
              );

            line-height:
              1.65;

            font-weight:
              500;

            letter-spacing:
              0.4px;

            text-shadow:
              0 3px 15px
              rgba(0,0,0,0.85);
          }


          /* ======================================================
             HERO LINE
          ====================================================== */

          .futuristic-hero-line {
            display:
              flex;

            align-items:
              center;

            justify-content:
              center;

            gap:
              6px;

            margin:
              25px auto 0;
          }


          .futuristic-hero-line span {
            height:
              2px;

            border-radius:
              5px;

            background:
              #00f6ff;

            box-shadow:
              0 0 10px
              rgba(0,246,255,0.75);
          }


          .futuristic-hero-line span:nth-child(1) {
            width: 35px;
            opacity: 0.35;
          }


          .futuristic-hero-line span:nth-child(2) {
            width: 75px;
          }


          .futuristic-hero-line span:nth-child(3) {
            width: 35px;
            opacity: 0.35;
          }


          /* ======================================================
             CORNER DETAILS
          ====================================================== */

          .hero-corner {
            position: absolute;

            z-index: 6;

            width: 45px;
            height: 45px;

            pointer-events:
              none;

            opacity:
              0.55;
          }


          .hero-corner-top-left {
            top: 25px;
            left: 25px;

            border-top:
              1px solid
              #00f6ff;

            border-left:
              1px solid
              #00f6ff;
          }


          .hero-corner-top-right {
            top: 25px;
            right: 25px;

            border-top:
              1px solid
              #8b5cff;

            border-right:
              1px solid
              #8b5cff;
          }


          .hero-corner-bottom-left {
            bottom: 25px;
            left: 25px;

            border-bottom:
              1px solid
              #8b5cff;

            border-left:
              1px solid
              #8b5cff;
          }


          .hero-corner-bottom-right {
            bottom: 25px;
            right: 25px;

            border-bottom:
              1px solid
              #00f6ff;

            border-right:
              1px solid
              #00f6ff;
          }


          /* ======================================================
             CAROUSEL ARROWS
          ====================================================== */

          .futuristic-carousel-control {
            z-index: 15;

            width:
              65px;

            opacity:
              0;

            transition:
              opacity 0.3s ease;
          }


          .futuristic-home-carousel:hover
          .futuristic-carousel-control {
            opacity:
              1;
          }


          .futuristic-arrow {
            width:
              44px;

            height:
              44px;

            display:
              flex;

            align-items:
              center;

            justify-content:
              center;

            border:
              1px solid
              rgba(0,246,255,0.35);

            border-radius:
              50%;

            background:
              rgba(3,10,20,0.65);

            backdrop-filter:
              blur(10px);

            color:
              #ffffff;

            font-size:
              32px;

            line-height:
              1;

            box-shadow:
              0 0 20px
              rgba(0,246,255,0.08);

            transition:
              all 0.25s ease;
          }


          .futuristic-arrow:hover {
            background:
              rgba(0,246,255,0.12);

            border-color:
              rgba(0,246,255,0.8);

            color:
              #00f6ff;

            box-shadow:
              0 0 25px
              rgba(0,246,255,0.20);
          }


          /* ======================================================
             INDICATORS
          ====================================================== */

          .futuristic-indicators {
            z-index: 20;

            bottom:
              23px;

            gap:
              7px;

            margin:
              0;
          }


          .futuristic-indicators button {
            width:
              20px !important;

            height:
              3px !important;

            margin:
              0 !important;

            padding:
              0 !important;

            border:
              none !important;

            border-radius:
              5px;

            background:
              rgba(255,255,255,0.35);

            opacity:
              1;

            transition:
              all 0.3s ease;
          }


          .futuristic-indicators button.active {
            width:
              45px !important;

            background:
              linear-gradient(
                90deg,
                #00f6ff,
                #8b5cff
              );

            box-shadow:
              0 0 10px
              rgba(0,246,255,0.65);
          }


          /* ======================================================
             BOTTOM SCAN LINE
          ====================================================== */

          .futuristic-bottom-scan-line {
            position:
              absolute;

            z-index:
              30;

            bottom:
              0;

            left:
              15%;

            right:
              15%;

            height:
              1px;

            background:
              linear-gradient(
                90deg,
                transparent,
                rgba(0,246,255,0.55),
                rgba(139,92,255,0.45),
                transparent
              );

            box-shadow:
              0 0 12px
              rgba(0,246,255,0.25);

            pointer-events:
              none;
          }


          /* ======================================================
             MOBILE
          ====================================================== */

          @media (max-width: 768px) {

            .futuristic-home-carousel {
              height:
                560px;
            }

            .futuristic-carousel-inner {
              height:
                560px;
            }

            .futuristic-home-carousel
            .carousel-item {
              height:
                560px;
            }

            .futuristic-banner-overlay {
              background:
                linear-gradient(
                  90deg,
                  rgba(2,5,12,0.82),
                  rgba(2,5,12,0.58),
                  rgba(2,5,12,0.76)
                );
            }

            .futuristic-hero-content {
              width:
                92%;

              padding:
                20px;
            }

            .futuristic-hero-title {
              font-size:
                clamp(
                  34px,
                  9vw,
                  52px
                );

              letter-spacing:
                -1px;
            }

            .futuristic-hero-description {
              font-size:
                15px;

              margin-top:
                18px;
            }

            .futuristic-hero-badge {
              font-size:
                8px;

              letter-spacing:
                2px;

              padding:
                7px 13px;
            }

            .futuristic-carousel-control {
              display:
                none;
            }

            .hero-corner {
              width:
                30px;

              height:
                30px;
            }

            .hero-corner-top-left,
            .hero-corner-top-right {
              top:
                15px;
            }

            .hero-corner-bottom-left,
            .hero-corner-bottom-right {
              bottom:
                15px;
            }

            .hero-corner-top-left,
            .hero-corner-bottom-left {
              left:
                15px;
            }

            .hero-corner-top-right,
            .hero-corner-bottom-right {
              right:
                15px;
            }

            .futuristic-indicators {
              bottom:
                18px;
            }
          }


          /* ======================================================
             SMALL PHONES
          ====================================================== */

          @media (max-width: 480px) {

            .futuristic-home-carousel {
              height:
                500px;
            }

            .futuristic-carousel-inner {
              height:
                500px;
            }

            .futuristic-home-carousel
            .carousel-item {
              height:
                500px;
            }

            .futuristic-hero-title {
              font-size:
                32px;
            }

            .futuristic-hero-description {
              font-size:
                14px;
            }

            .futuristic-cyan-glow {
              width:
                280px;

              height:
                280px;
            }

            .futuristic-purple-glow {
              width:
                300px;

              height:
                300px;
            }
          }


          /* ======================================================
             ACCESSIBILITY
          ====================================================== */

          @media (prefers-reduced-motion: reduce) {

            .futuristic-banner-image {
              transition:
                none !important;

              transform:
                scale(1) !important;
            }

            .futuristic-arrow,
            .futuristic-indicators button {
              transition:
                none !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default HomeCarousel;